<template>
  <div class="container admin-roles-page">
    <div class="param-title-wrap">
      <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
      </b-button>
      <h2 class="param-title">{{labels.title}}</h2>
    </div>
    <div class="admin-table-block mt-4" v-if="roles?.length">
      <CorporateDataTable
        :items="roles"
        :fields="allFields"
        :filter-defs="tableFilterDefs"
        :labels="tableLabels"
        :default-per-page="10"
        :page-options="[10, 20, 50, 100]"
        :narrow="false"
        :table-min-height="500"
        :table-max-height="500"
      >
        <template #toolbar-actions>
          <b-button size="sm" class="table-toolbar-add-btn" @click="createRol()">
            {{ labels.create }}
          </b-button>
        </template>
        <template #cell(asociar)="data">
          <b-button
            style="background-color: #2e5072; width: 30px; height: 30px;"
            class="md-fab md-primary table-action-btn"
            @click="asociaMenu(data.item.id)" 
          >
            <i><font-awesome-icon :icon="['fas', 'cubes']" size="xs"/></i>
          </b-button>
        </template>
        <template #cell(accionEdit)="data">
          <b-button
            style="background-color: #FF924C; width: 30px; height: 30px;"
            class="md-fab md-primary table-action-btn"
            @click="editRol(data.item.id)" 
          >
            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
          </b-button>
        </template>
        <template #cell(accionInac)="data">
          <b-button v-if="data.item?.estado == 1"
            variant="link"
            class="p-0 border-0 shadow-none table-action-btn"
            @click="inactivarRol(data.item)"
          >
            <i><font-awesome-icon :icon="['fas', 'toggle-on']" size="xl"/></i>
          </b-button>
          <b-button v-else
            variant="link"
            class="p-0 border-0 shadow-none table-action-btn"
            @click="activarRol(data.item)"
          >
            <i><font-awesome-icon :icon="['fas', 'toggle-off']" size="xl"/></i>
          </b-button>
        </template>
      </CorporateDataTable>
    </div>
    <div class="admin-table-block mt-4" v-else>
      <h5>{{ labels.notFoundMessage }}</h5>
    </div>
    
    <!-- Modales -->
    <Create :showDialogCreate="showDialogCreate" @closeModal="cerrarModal" @created="cargarRoles"/>
    <Edit :showDialogEdit="showDialogEdit" :Item="itemSelected" @closeModal="cerrarModal" @updated="actualizarRolEnLista"/>
    <ModalAsociaMenu :modAsociaMenu="modAsociaMenu" :IdRol="rolId" @closeModal="cerrarModal"></ModalAsociaMenu>
    <InacticaItem 
      :InactivaItem="showInactivateModal" 
      @confirmDelete="confirmInactivate" 
      @cierraModal="cerrarModal"
    />
  </div>
</template>

<script>
import Rol from "@/services/Roles";
import CorporateDataTable from "../utils/CorporateDataTable.vue";
import Edit from "./Edit.vue" 
import Create from './Create.vue'; 
import ModalAsociaMenu from "./ModalAsociaMenu.vue"; 
import InacticaItem from "../utils/InacticaItem.vue"; 

export default {
    name: "Roles",
    components: {
      Edit,
      Create,
      ModalAsociaMenu,
      CorporateDataTable,
      InacticaItem
    },
    data: () => ({
      isLoading: false,
      error: false,
      isEmpty: false,
      searchRoles: null,
      roles: [],
      showDialogEdit: false,
      itemSelected: {},
      listRol: [],
      showDialogCreate: false,
      modAsociaMenu: false,
      rolId: "",
      showInactivateModal: false,
      rolToInactivate: null,
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Roles",
                    instructive: ["Bienvenid@ a la plataforma para la visualización y administración de roles"],
                    create: "Añadir rol",
                    name: "Nombre",
                    description: "Descripción",
                    associate: "Asociar rol",
                    edit: "Editar",
                    inactivate: "Inactivar",
                    status: "Estado",
                    notFoundMessage: "No hay registros"
                }
            } else {
                return {
                    title: "Roles",
                    instructive: ["Welcome to the platform for the visualization and manage of roles."], 
                    create: "Add role",
                    name: "Name",
                    description: "Description",
                    associate: "Associate menu",
                    edit: "Edit",
                    inactivate: "Inactivate",
                    status: "Status",
                    notFoundMessage: "No records found"
                }
            }
        },
        allFields() {
          return [
            { key: 'nombre', label: this.labels.name, sortable: true },
            { key: 'descripcion', label: this.labels.description, sortable: true },
            { key: 'asociar', label: this.labels.associate, thClass: 'text-center', tdClass: 'text-center', sortable: false },
            { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center', sortable: false },
            { key: 'accionInac', label: this.labels.status, thClass: 'text-center', tdClass: 'text-center', sortable: false }
          ];
        },
        tableFilterDefs() {
          return [
            { key: 'nombre', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar nombre...' : 'Filter name...' },
            { key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
          ];
        },
        tableLabels() {
          return {
            noRow: this.labels.notFoundMessage,
            noMatches: this.$store.state._language == "es-ES" ? "No se encontraron resultados" : "No results found",
            searchPlaceholder: this.$store.state._language == "es-ES" ? "Buscar en la tabla..." : "Search in table...",
            rowsPerPage: this.$store.state._language == "es-ES" ? "Filas por página:" : "Rows per page:",
            noSort: this.$store.state._language == "es-ES" ? "Sin orden" : "No sorting",
            sortAsc: this.$store.state._language == "es-ES" ? "A-Z / Menor a mayor" : "A-Z / Low to high",
            sortDesc: this.$store.state._language == "es-ES" ? "Z-A / Mayor a menor" : "Z-A / High to low",
            columns: this.$store.state._language == "es-ES" ? "Columnas" : "Columns",
            showAllColumns: this.$store.state._language == "es-ES" ? "Mostrar todas" : "Show all",
            filters: this.$store.state._language == "es-ES" ? "Filtros" : "Filters",
            clearFilters: this.$store.state._language == "es-ES" ? "Limpiar filtros" : "Clear filters"
          };
        }
    },
    methods: {
      goBack() {
        this.$router.back()
      },
      cerrarModal(val) {
        this.showDialogEdit = val 
        this.showDialogCreate = val 
        this.modAsociaMenu = val
        this.showInactivateModal = val 
      },
      cargarRoles() {
        this.isLoading = true;
        Rol.getAllRoles() 
          .then((rta) => { 
            this.roles = rta.data.roles; 
          })
          .catch(() => { 
            this.error = true; 
          })
          .finally(() => { 
            this.isLoading = false; 
          });
      },
      actualizarRolEnLista(datosActualizados) {
        this.roles = this.roles.map((rol) => {
          if ((rol.id || rol.idRol || rol._id) === datosActualizados.id) {
            return {
              ...rol,
              nombre: datosActualizados.nombre,
              descripcion: datosActualizados.descripcion
            }
          }
          return rol
        })
      },
      asociaMenu(idRol) {
        if (!idRol) {
          console.error('ID de rol no válido:', idRol);
          return;
        }
        this.rolId = idRol 
        this.modAsociaMenu = true 
      },
      editRol(id) {
        this.showDialogEdit = true; 
        Rol.getAllRolesById(id) 
          .then((rta) => { 
            let datos = rta.data.rolById; 
            this.itemSelected = datos[0]; 
          })
          .catch((error) => { 
            console.log(error); 
            this.error = true; 
          })
          .finally(() => { 
            this.isLoading = false; 
          });
      },
      createRol() {
        this.showDialogCreate = true 
      },
      inactivarRol(rol) {
        this.rolToInactivate = rol;
        this.showInactivateModal = true;
      },
      confirmInactivate() {
        if (!this.rolToInactivate) return;
        
        const id = this.rolToInactivate.id || this.rolToInactivate.idRol || this.rolToInactivate._id;
        if (!id) return;

        this.isLoading = true; 
        Rol.inactivarRol(id) 
          .then(() => { 
            this.$toast.success("Rol inactivado correctamente") 
            this.roles = this.roles.map((rol) => (
              rol.id === id ? { ...rol, estado: 0 } : rol
            ))
            this.showInactivateModal = false;
            this.rolToInactivate = null;
          })
          .catch(() => { 
            this.$toast.error("El rol no se pudo inactivar") 
          })
          .finally(() => { 
            this.isLoading = false; 
          });
      },
      activarRol(rol) {
        const id = rol.id || rol.idRol || rol._id;
        if (!id) {
          this.$toast.error("No se pudo obtener el ID del rol")
          return;
        }

        this.isLoading = true;
        
        Rol.activarRol(id)
          .then(() => {
            this.$toast.success("Rol activado correctamente")
            this.roles = this.roles.map((r) => (
              r.id === id ? { ...r, estado: 1 } : r
            ))
          })
          .catch((error) => {
            console.error(error)
            this.$toast.error("El rol no se pudo activar")
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
    },
    mounted() {
      this.cargarRoles();
    }
}
</script>
<style src="../main.css"> 
</style>